module.exports = __webpack_public_path__ + "static/img/图层 20.27fd5b41.png";